module.exports = __webpack_public_path__ + "assets/img/bjt.dd73fd26.png";